<template>
    <main class="main__forgot__password__wrapper">
        <div class="signin__flow__individual__wrap">
            <div class="restore__your__account__wrapper">
                <div class="title__cover__block signin__title__box">
                    <h4 class="title">{{ resetPassword ? 'Reset Password' : 'Forgot Password' }}</h4>
                    <div class="short__note">
                        <p v-if="!resetPassword">Enter your email account to reset password</p>
                        <p v-else>Enter your new password and confirm password.</p>
                    </div>
                </div>

                <div class="signin__form__wrapper">
                    <form @submit.prevent="onSubmit">
                        <div class="form__input__field">
                            <label>{{ resetPassword ? 'Email Address' : 'Enter Your Email Address' }}</label>
                            <input type="text" placeholder="Enter Email" v-model.trim="email" :readonly="resetPassword"
                                :disabled="resetPassword" @input="email = $event.target.value.toLowerCase()" />
                            <span class="error__message" v-if="submitted && emailError">{{ emailError }}</span>
                        </div>
                        <template v-if="resetPassword">
                            <div class="form__input__field psw__field__box">
                                <div class="input__field">
                                    <label>Password</label>
                                    <input type="password" placeholder="Enter your password" v-model.trim="password" />
                                    <span class="error__message" v-if="submitted && passwordError">{{ passwordError
                                    }}</span>
                                </div>
                            </div>
                            <div class="form__input__field psw__field__box">
                                <div class="input__field">
                                    <label>Confirm Password</label>
                                    <input type="password" placeholder="Enter your password"
                                        v-model.trim="confirmPassword" />
                                    <span class="error__message" v-if="submitted && confirmPasswordError">{{
                                        confirmPasswordError
                                        }}</span>
                                </div>
                            </div>
                        </template>

                        <div class="form__sign__btn">
                            <button type="submit" class="sign__in__btn" :disabled="submitting">
                                Submit
                            </button>
                        </div>

                        <div class="signin__options__box">
                            <span class="signin__label">Need an EESA APP Account?</span>
                            <span class="create__account__link">
                                <router-link to="/register">Create an account</router-link>
                            </span>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <BaseModal :visible="showOtpModal" title="Verify Your Email Address" size="medium"
            id="change__your__photo__popup" class="change__your__photo__popup" @close="showOtpModal = false">

            <div class="otp__verification">
                <svg xmlns="http://www.w3.org/2000/svg" width="85" height="86" viewBox="0 0 85 86" fill="none">
                    <g clip-path="url(#clip0_2469_38227)">
                        <path
                            d="M45.5 56H42H39L36 54.5L13.5 38.5V7L15 4.5L17 2L19.5 1H28.5L67.5 2L70 4.5L71 7L71.5 38L49 54.5L45.5 56Z"
                            fill="#41B9FE" stroke="black"></path>
                        <path
                            d="M79.5974 63.153C80.2945 63.153 80.86 62.5808 80.86 61.8755V32.9711C80.86 32.5505 80.6551 32.1575 80.3127 31.9187L72.2304 26.293V8.19766C72.2304 3.6776 68.5956 0 64.1281 0H29.1584C28.4613 0 27.8965 0.572144 27.8965 1.27748C27.8965 1.98282 28.4613 2.55431 29.1584 2.55431H64.1281C67.2033 2.55431 69.7052 5.08565 69.7052 8.19766V26.9524V26.9537V38.3061L49.2184 52.5657C45.1537 55.3956 39.6914 55.3956 35.6266 52.5657L15.1385 38.3054V26.9537C15.1385 26.9531 15.1385 26.9524 15.1385 26.9524V8.19766C15.1385 5.08565 17.6405 2.55431 20.7163 2.55431H24.1092C24.8064 2.55431 25.3719 1.98282 25.3719 1.27748C25.3719 0.572144 24.8064 0 24.1092 0H20.7163C16.2488 0 12.6139 3.6776 12.6139 8.19766V26.293L4.53106 31.9187C4.18865 32.1568 3.98438 32.5505 3.98438 32.9711V76.8037C3.98438 81.8749 8.06278 86 13.075 86H71.7706C76.7822 86 80.86 81.8749 80.86 76.8037V66.9644C80.86 66.2591 80.2951 65.6869 79.5974 65.6869C78.9002 65.6869 78.3354 66.2591 78.3354 66.9644V76.8037C78.3354 80.4662 75.3905 83.4457 71.7706 83.4457H13.075C9.45446 83.4457 6.50898 80.4662 6.50898 76.8037V35.3994L34.1953 54.6705C34.9288 55.181 35.7005 55.6173 36.5007 55.9802C35.7005 56.343 34.9288 56.7793 34.1953 57.2898L10.3902 73.8597C9.81632 74.2592 9.67106 75.0545 10.066 75.6358C10.3105 75.996 10.7054 76.1896 11.1068 76.1896C11.3539 76.1896 11.6029 76.1167 11.8215 75.9645L35.6266 59.394C39.6914 56.5648 45.1543 56.5654 49.2191 59.394L73.0229 75.9645C73.5975 76.3641 74.3834 76.2171 74.7784 75.6358C75.1733 75.0551 75.028 74.2599 74.4535 73.8597L50.6503 57.2898C49.9169 56.7793 49.1452 56.343 48.3443 55.9802C49.1445 55.6173 49.9162 55.181 50.6497 54.6705L78.3347 35.3994V61.8755C78.3347 62.5808 78.9002 63.153 79.5974 63.153ZM12.6139 36.5476L7.47459 32.9704L12.6139 29.3939V36.5476ZM72.2304 29.3939L77.3698 32.9711L72.2304 36.5483V29.3939Z"
                            fill="black"></path>
                        <path
                            d="M27.338 24.597C26.9897 23.9861 26.2174 23.7768 25.6136 24.1292L24.0047 25.0694V23.1896C24.0047 22.4843 23.4398 21.9121 22.7421 21.9121C22.0449 21.9121 21.4801 22.4843 21.4801 23.1896V25.0694L19.8705 24.1292C19.2667 23.7762 18.495 23.9861 18.1461 24.597C17.7979 25.2078 18.0048 25.9886 18.6085 26.3416L20.2174 27.2812L18.6085 28.2214C18.0048 28.5738 17.7979 29.3552 18.1461 29.9661C18.3803 30.3755 18.8044 30.6045 19.2408 30.6045C19.4548 30.6045 19.6721 30.5494 19.8705 30.4332L21.4801 29.4937V31.3735C21.4801 32.0788 22.0449 32.6503 22.7421 32.6503C23.4398 32.6503 24.0047 32.0788 24.0047 31.3735V29.4937L25.6136 30.4332C25.8127 30.5494 26.0299 30.6045 26.2439 30.6045C26.6804 30.6045 27.1045 30.3755 27.338 29.9661C27.6869 29.3552 27.48 28.5738 26.8762 28.2214L25.2673 27.2812L26.8762 26.3416C27.48 25.9886 27.6869 25.2078 27.338 24.597Z"
                            fill="black"></path>
                        <path
                            d="M40.4581 24.9959C40.1098 24.3851 39.3375 24.1758 38.7337 24.5287L37.1248 25.4683V23.5885C37.1248 22.8832 36.5593 22.311 35.8622 22.311C35.165 22.311 34.6002 22.8832 34.6002 23.5885V25.4683L32.9906 24.5287C32.3862 24.1758 31.6145 24.3851 31.2663 24.9959C30.918 25.6068 31.1249 26.3882 31.7286 26.7406L33.3376 27.6808L31.7286 28.6204C31.1249 28.9734 30.918 29.7542 31.2663 30.365C31.5004 30.7751 31.9245 31.0041 32.3609 31.0041C32.5749 31.0041 32.7922 30.949 32.9906 30.8328L34.6002 29.8926V31.7724C34.6002 32.4777 35.165 33.0499 35.8622 33.0499C36.5593 33.0499 37.1248 32.4777 37.1248 31.7724V29.8926L38.7337 30.8328C38.9328 30.949 39.1494 31.0041 39.3641 31.0041C39.7999 31.0041 40.2246 30.7751 40.4581 30.365C40.807 29.7542 40.6001 28.9734 39.9963 28.6204L38.3868 27.6808L39.9963 26.7406C40.6001 26.3882 40.807 25.6068 40.4581 24.9959Z"
                            fill="black"></path>
                        <path
                            d="M53.5777 24.9959C53.2295 24.3851 52.4571 24.1758 51.8534 24.5287L50.2444 25.4683V23.5885C50.2444 22.8832 49.6789 22.311 48.9818 22.311C48.2847 22.311 47.7198 22.8832 47.7198 23.5885V25.4683L46.1102 24.5287C45.5065 24.1758 44.7341 24.3851 44.3859 24.9959C44.0376 25.6068 44.2445 26.3882 44.8483 26.7406L46.4572 27.6808L44.8483 28.6204C44.2445 28.9734 44.0376 29.7542 44.3859 30.365C44.62 30.7751 45.0441 31.0041 45.4806 31.0041C45.6946 31.0041 45.9118 30.949 46.1102 30.8328L47.7198 29.8926V31.7724C47.7198 32.4777 48.2847 33.0499 48.9818 33.0499C49.6789 33.0499 50.2444 32.4777 50.2444 31.7724V29.8926L51.8534 30.8328C52.0524 30.949 52.269 31.0041 52.4837 31.0041C52.9195 31.0041 53.3442 30.7751 53.5777 30.365C53.9266 29.7542 53.7197 28.9734 53.116 28.6204L51.5064 27.6808L53.116 26.7406C53.7197 26.3882 53.9266 25.6068 53.5777 24.9959Z"
                            fill="black"></path>
                        <path
                            d="M62.1014 22.3115C61.4043 22.3115 60.8394 22.883 60.8394 23.5883V25.4688L59.2299 24.5286C58.6261 24.1756 57.8544 24.3855 57.5055 24.9964C57.1573 25.6073 57.3641 26.388 57.9679 26.741L59.5768 27.6806L57.9679 28.6208C57.3641 28.9732 57.1573 29.7546 57.5055 30.3655C57.7396 30.7749 58.1637 31.0039 58.6002 31.0039C58.8142 31.0039 59.0314 30.9488 59.2299 30.8327L60.8394 29.8931V31.7722C60.8394 32.4782 61.4043 33.0497 62.1014 33.0497C62.7992 33.0497 63.3641 32.4782 63.3641 31.7722V29.8931L64.973 30.8327C65.1721 30.9488 65.3887 31.0039 65.6033 31.0039C66.0391 31.0039 66.4639 30.7749 66.6973 30.3655C67.0462 29.7546 66.8394 28.9732 66.2356 28.6208L64.626 27.6806L66.2356 26.741C66.8394 26.388 67.0462 25.6073 66.6973 24.9964C66.3491 24.3849 65.5767 24.1762 64.973 24.5286L63.3641 25.4688V23.5883C63.3641 22.883 62.7992 22.3115 62.1014 22.3115Z"
                            fill="black"></path>
                        <path
                            d="M52.6095 11.4693C53.3073 11.4693 53.8721 10.8979 53.8721 10.1919C53.8721 9.48653 53.3073 8.91504 52.6095 8.91504H32.2356C31.5385 8.91504 30.9736 9.48653 30.9736 10.1919C30.9736 10.8979 31.5385 11.4693 32.2356 11.4693H52.6095Z"
                            fill="black"></path>
                        <path
                            d="M23.3335 15.2846C23.3335 15.99 23.8983 16.5621 24.5955 16.5621H60.2499C60.9471 16.5621 61.5126 15.99 61.5126 15.2846C61.5126 14.5793 60.9471 14.0078 60.2499 14.0078H24.5955C23.8983 14.0078 23.3335 14.5793 23.3335 15.2846Z"
                            fill="black"></path>
                    </g>
                    <defs>
                        <clipPath id="clip0_2469_38227">
                            <rect width="85" height="86" fill="white"></rect>
                        </clipPath>
                    </defs>
                </svg>

                <p class="">One-Time Password sent to your registered email address</p>
                <div class="otp-container">
                    <div class="otp-inputs">
                        <input v-for="(digit, index) in otp" :key="index" type="password" class="otp-field"
                            maxlength="1" v-model="otp[index]" @input="handleInput(index, $event)"
                            @keydown.backspace="handleBackspace(index, $event)" @paste="handlePaste" ref="otpRefs" />
                    </div>

                    <div class="rlms-flex rlms-align-items-center rlms-gap-5">
                        Didn’t receive the OTP?
                        <div>
                            <a href="javascript:void(0);" class="resend-otp-link" @click="resentOtp">Resend OTP</a>
                        </div>
                    </div>
                    <button type="button" class="eesa-primary-btn rlms-mx-auto" :disabled="submitting"
                        @click="verifyOtp">
                        {{ submitting ? 'Processing...' : 'Verify OTP' }}
                    </button>
                </div>
            </div>
        </BaseModal>
    </main>
</template>

<script setup>
import { nextTick, ref } from 'vue';
import { useForm, useField } from 'vee-validate'
import * as yup from 'yup'
import api from '@/services/axios';
import BaseModal from '@/components/BaseModal.vue';
import { showToast } from '@/utils/swal';
import { useLoaderStore } from '@/stores/loader';
import { useRouter } from 'vue-router';
import { handleError } from '@/utils/handleError';

const router = useRouter();
const loader = useLoaderStore();

const submitting = ref(false);
const submitted = ref(false);

const showOtpModal = ref(false);
// Create a 6-digit OTP state
const otp = ref(Array(6).fill(''))
const otpRefs = ref([]);
const resetPassword = ref(false);

// Define Yup validation schema
const schema = yup.object({
    email: yup.string().email('Please enter a valid email.').required('Please enter your email.').test(
        'has-dot-in-domain',
        'Please enter a valid email.',
        (value) => {
            if (!value) return false;
            const domain = value.split('@')[1];
            return domain && domain.includes('.');
        }
    ),
    setPassword: yup.boolean(), // This flag determines whether to require password fields
    password: yup.string().when('setPassword', { is: true, then: (schema) => schema.min(6, 'Password must be at least 6 characters.').required('Password is required.'), otherwise: (schema) => schema.notRequired(), }),
    confirmPassword: yup.string().when('setPassword', { is: true, then: (schema) => schema.oneOf([yup.ref('password')], 'Passwords must match.').required('Please confirm your password.'), otherwise: (schema) => schema.notRequired(), }),
});


// Initialize vee-validate form with schema
const { handleSubmit, setErrors } = useForm({
    validationSchema: schema,
})

// Setup fields
const { value: email, errorMessage: emailError } = useField('email');
const { value: setPassword } = useField('setPassword')
const { value: password, errorMessage: passwordError } = useField('password')
const { value: confirmPassword, errorMessage: confirmPasswordError } = useField('confirmPassword')
const { value: otpInput } = useField('otpInput')

const resentOtp = async () => {
    await handleSubmit(async (values) => {
        loader.show();
        await api.post('/send-otp', { identifier: values.email, type: 'reset-password' });

        showToast({
            icon: 'success',
            title: 'OTP Sent!',
            text: "A 6-digit OTP has been sent to your email address.",
        });

        showOtpModal.value = true
        loader.hide();
    })();
}

// Form submit handler
const onSubmit = async () => {
    submitted.value = true;

    await handleSubmit(async (values) => {
        submitting.value = true;
        loader.show();
        try {
            if (resetPassword.value) {
                await api.post('/reset-password', {
                    email: values.email,
                    password: values.password,
                    otp: values.otpInput,
                });

                showToast({
                    icon: 'success',
                    title: 'Success!',
                    text: "Password reset successfully!",
                });

                router.push('/login');
            } else {
                await api.post('/forgot-password', {
                    email: values.email
                });

                showToast({
                    icon: 'success',
                    title: 'OTP Sent!',
                    text: "A 6-digit OTP has been sent to your email address.",
                });

                showOtpModal.value = true
            }
        } catch (error) {
            if (error.response?.status === 422) {
                const serverErrors = error?.response?.data?.errors || {};
                const fieldErrors = {};

                Object.keys(serverErrors).forEach(key => {
                    fieldErrors[key] = serverErrors[key][0];
                });

                if (Object.keys(fieldErrors).length > 0) {
                    setErrors(fieldErrors);
                } else {
                    handleError(error, true);
                }
            } else {
                handleError(error);
            }

        } finally {
            loader.hide();
            submitting.value = false;
        }
    })();
};

// Form submit handler
const verifyOtp = async () => {
    submitted.value = true;

    await handleSubmit(async (values) => {
        submitting.value = true;
        loader.show();
        try {
            await api.post('/verify-otp', {
                identifier: values.email,
                otp: values.otpInput,
            });

            showToast({
                icon: 'success',
                title: 'Success!',
                text: "Otp verified successfully.",
            });

            showOtpModal.value = false;
            submitting.value = false;
            submitted.value = false;
            setPassword.value = true;
            resetPassword.value = true;
        } catch (error) {
            showToast({
                title: 'Oops!',
                text: error?.response?.data?.message ?? 'Something went wrong. Please try again later!',
                icon: 'error',
            });
        } finally {
            loader.hide();
            submitting.value = false;
        }
    })();
};

// Final OTP submission
function submitOtp() {
    const fullOtp = otp.value.join('')
    otpInput.value = fullOtp;

    // onSubmit();
}

// Auto-focus next input on valid entry
function handleInput(index, event) {
    const value = event.target.value.replace(/\D/g, '') // Only digits
    otp.value[index] = value

    if (value && index < otp.value.length - 1) {
        nextTick(() => otpRefs.value[index + 1]?.focus())
    }

    // Optional auto-submit
    if (otp.value.every(d => d !== '')) {
        submitOtp()
    }
}

// Handle backspace to go to previous input
function handleBackspace(index) {
    if (otp.value[index] === '' && index > 0) {
        nextTick(() => otpRefs.value[index - 1]?.focus())
    }
}

// Handle full paste
function handlePaste(event) {
    event.preventDefault()
    const pasted = (event.clipboardData || window.clipboardData)
        .getData('text')
        .replace(/\D/g, '')
        .slice(0, 6)

    for (let i = 0; i < pasted.length; i++) {
        otp.value[i] = pasted[i]
    }

    nextTick(() => otpRefs.value[pasted.length - 1]?.focus())

    if (pasted.length === 6) {
        submitOtp()
    }
}
</script>